import fa from "element-ui/src/locale/lang/fa";

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

// import EXIF from "exif-js";
//
// //获取url上的参数
// function getQueryString(name) {
//   let str = window.location.href;
//   let obj = {};
//   getUrlFn(str, obj);
//   if (obj[name] != null) return obj[name];
//   return null;
// }
//
// function getUrlFn(name, obj) {
//   let arr = [];
//   let num = name.indexOf("?");
//   arr = name.substr(num + 1).split("&");
//   arr.map(btn => {
//     let num2 = btn.indexOf("?");
//     if (num2 !== -1) {
//       getUrlFn(btn, obj);
//     } else {
//       let arr2 = btn.split("=");
//       obj[arr2[0]] = arr2[1];
//     }
//   });
// }
//
// //图片压缩
// function compress(fileObj, callback, Orientation) {
//   let _this = this;
//   // fileobj 文件对象
//   // callback 回调 返回压缩后的文件
//   if (fileObj.size < 307200 && (Orientation == undefined || Orientation == 1 || Orientation == 2 || Orientation == 0)) {
//     callback(fileObj);
//     return;
//   }
//   try {
//     const image = new Image();
//     image.src = URL.createObjectURL(fileObj);
//     image.onload = function() {
//       var imgWidth = this.width,
//           imgHeight = this.height;
//       // 控制上传图片的宽高
//       if (imgWidth > imgHeight) {
//         imgWidth = 800;
//         imgHeight = this.height / (this.width / 800);
//       } else if (imgWidth < imgHeight) {
//         imgWidth = this.width / (this.height / 800);
//         imgHeight = 800;
//       }
//       console.log(imgHeight)
//       var canvas = document.createElement("canvas"),
//           ctx = canvas.getContext("2d");
//       canvas.width = imgWidth;
//       canvas.height = imgHeight;
//       ctx.drawImage(this, 0, 0, imgWidth, imgHeight);
//       let data = canvas.toDataURL("image/jpeg", .9);
//       // const that = this;
//       // // 默认按比例压缩
//       // let w = that.width;
//       // let h = that.height;
//       // const scale = w / h;
//       // w = fileObj.width || w;
//       // h = fileObj.height || (w / scale);
//       // let quality = 0.1; // 默认图片质量为0.7
//       // // 生成canvas
//       // const canvas = document.createElement("canvas");
//       // const ctx = canvas.getContext("2d");
//       // // if (Orientation == undefined || Orientation == 1 || Orientation == 2 || Orientation == 0) {
//       //   // 创建属性节点
//       //   const anw = document.createAttribute("width");
//       //   anw.nodeValue = w;
//       //   const anh = document.createAttribute("height");
//       //   anh.nodeValue = h;
//       //   canvas.setAttributeNode(anw);
//       //   canvas.setAttributeNode(anh);
//       //   ctx.drawImage(that, 0, 0, w, h);
//       // } else {
//       //   // 创建属性节点
//       //   const anw = document.createAttribute("width");
//       //   anw.nodeValue = h;
//       //   const anh = document.createAttribute("height");
//       //   anh.nodeValue = w;
//       //   canvas.setAttributeNode(anw);
//       //   canvas.setAttributeNode(anh);
//       //   if (Orientation == 3 || Orientation == 4) {
//       //     ctx.rotate(Math.PI);
//       //     ctx.drawImage(that, -w, -h, w, h);
//       //   } else if (Orientation == 5 || Orientation == 6) {
//       //     ctx.rotate(Math.PI / 2);
//       //     ctx.drawImage(that, 0, -h, w, h);
//       //   } else if (Orientation == 7 || Orientation == 8) {
//       //     ctx.rotate(3 * Math.PI / 2);
//       //     ctx.drawImage(that, -w, 0, w, h);
//   // }
//   //     }
//       // 图像质量
//       // if (fileObj.quality && fileObj.quality <= 1 && fileObj.quality > 0) {
//       //   quality = fileObj.quality;
//   // }
//       // quality值越小，所绘制出的图像越模糊
//       // const data = canvas.toDataURL("image/jpeg", quality);
//       // 压缩完成执行回调
//       const newFile = convertBase64UrlToBlob(data);
//       console.log(newFile)
//       callback(newFile);
//     };
//   } catch (e) {
//     alert("压缩失败!");
//   }
// }
//
// function compresstypeB(fileObj, callback) {
//   var Orientation = null;
//   var isRotate = true
//   // console.log(getIos())
//   // console.log(versionIOS())
//   // if (getIos() !== 'IOS') {
//   //   isRotate = true
//   // } else {
//   //   isRotate = version() <= 1340 ? true :false
//   //
//   // }
//   if ((!getIos() || getIos() === 'IOS') && versionIOS()) {
//     console.log('不旋转')
//     EXIF.getData(fileObj, function() {
//       Orientation = EXIF.getTag(this, "Orientation");
//       var image = new Image();
//       image.src = URL.createObjectURL(fileObj);
//       image.onload = function() {
//         var imgWidth = this.width,
//             imgHeight = this.height;
//         // 控制上传图片的宽高
//         if (imgWidth > imgHeight) {
//           imgWidth = 400;
//           imgHeight = this.height / (this.width / 400);
//         } else if (imgWidth < imgHeight) {
//           imgWidth = this.width / (this.height / 400);
//           imgHeight = 400;
//         }
//
//         var canvas = document.createElement("canvas"),
//             ctx = canvas.getContext("2d");
//         canvas.width = imgWidth;
//         canvas.height = imgHeight;
//         // if (Orientation && Orientation !== 1 && Orientation !== 0 && isRotate) {
//         // if (Orientation && Orientation !== 1 && Orientati901028on !== 0) {
//         //   switch (Orientation) {
//         //     case 6:     // 旋转90度
//         //       canvas.width = imgHeight;
//         //       canvas.height = imgWidth;
//         //       ctx.rotate(Math.PI / 2);
//         //       // (0,-imgHeight) 从旋转原理图那里获得的起始点
//         //       ctx.drawImage(this, 0, -imgHeight, imgWidth, imgHeight);
//         //       break;
//         //     case 3:     // 旋转180度
//         //       ctx.rotate(Math.PI);
//         //       ctx.drawImage(this, -imgWidth, -imgHeight, imgWidth, imgHeight);
//         //       break;
//         //     case 8:     // 旋转-90度
//         //       canvas.width = imgHeight;
//         //       canvas.height = imgWidth;
//         //       ctx.rotate(3 * Math.PI / 2);
//         //       ctx.drawImage(this, -imgWidth, 0, imgWidth, imgHeight);
//         //       break;
//         //   }
//         // } else {
//         ctx.drawImage(this, 0, 0, imgWidth, imgHeight);
//         // }
//
//         let data = canvas.toDataURL("image/jpeg", .9);
//
//         // 压缩完成执行回调
//         const newFile = convertBase64UrlToBlob(data);
//         callback(newFile);
//       };
//     });
//   } else {
//     EXIF.getData(fileObj, function() {
//       console.log('旋转')
//       Orientation = EXIF.getTag(this, "Orientation");
//       var image = new Image();
//       image.src = URL.createObjectURL(fileObj);
//       image.onload = function() {
//         var imgWidth = this.width,
//             imgHeight = this.height;
//         // 控制上传图片的宽高
//         if (imgWidth > imgHeight) {
//           imgWidth = 400;
//           imgHeight = this.height / (this.width / 400);
//         } else if (imgWidth < imgHeight) {
//           imgWidth = this.width / (this.height / 400);
//           imgHeight = 400;
//         }
//
//         var canvas = document.createElement("canvas"),
//             ctx = canvas.getContext("2d");
//         canvas.width = imgWidth;
//         canvas.height = imgHeight;
//         // if (Orientation && Orientation !== 1 && Orientation !== 0 && isRotate) {
//         if (Orientation && Orientation !== 1 && Orientation !== 0) {
//           switch (Orientation) {
//             case 6:     // 旋转90度
//               canvas.width = imgHeight;
//               canvas.height = imgWidth;
//               ctx.rotate(Math.PI / 2);
//               // (0,-imgHeight) 从旋转原理图那里获得的起始点
//               ctx.drawImage(this, 0, -imgHeight, imgWidth, imgHeight);
//               break;
//             case 3:     // 旋转180度
//               ctx.rotate(Math.PI);
//               ctx.drawImage(this, -imgWidth, -imgHeight, imgWidth, imgHeight);
//               break;
//             case 8:     // 旋转-90度
//               canvas.width = imgHeight;
//               canvas.height = imgWidth;
//               ctx.rotate(3 * Math.PI / 2);
//               ctx.drawImage(this, -imgWidth, 0, imgWidth, imgHeight);
//               break;
//           }
//         } else {
//         ctx.drawImage(this, 0, 0, imgWidth, imgHeight);
//         }
//
//         let data = canvas.toDataURL("image/jpeg", .9);
//
//         // 压缩完成执行回调
//         const newFile = convertBase64UrlToBlob(data);
//         callback(newFile);
//       };
//     });
//   }
//
//
// }
//
// //base64转blob
// function convertBase64UrlToBlob(urlData) {
//   const bytes = window.atob(urlData.split(",")[1]); // 去掉url的头，并转换为byte
//   // 处理异常,将ascii码小于0的转换为大于0
//   const ab = new ArrayBuffer(bytes.length);
//   const ia = new Uint8Array(ab);
//   for (let i = 0; i < bytes.length; i++) {
//     ia[i] = bytes.charCodeAt(i);
//   }
//   return new Blob([ab], { type: "image/jpg" });
// }
//
// //深度拷贝
// function deepClone(obj){
//   let objClone = Array.isArray(obj)?[]:{};
//   if(obj && typeof obj==="object"){
//     for(let name in obj){
//       if(obj.hasOwnProperty(name)){
//         //判断ojb子元素是否为对象，如果是，递归复制
//         if(obj[name]&&typeof obj[name] ==="object"){
//           objClone[name] = deepClone(obj[name]);
//         }else{
//           //如果不是，简单复制
//           objClone[name] = obj[name];
//         }
//       }
//     }
//   }
//   return objClone;
// }
// //获取手机系统版本号
// function version() {
//   var str= navigator.userAgent.toLowerCase();
//   var ver=str.match(/cpu iphone os (.*?) like mac os/);
//   return (ver[1].replace(/_/g,""))*1
// }
// function versionIOS() {
//   var ua = navigator.userAgent.toLowerCase();
//
//   if(ua.indexOf("like mac os x") > 0){
//     var reg = /os [\d._]*/gi ;
//     var verinfo = ua.match(reg) ;
//     var version = (verinfo+"").replace(/[^0-9|_.]/ig,"").replace(/_/ig,".");
//     var arr=version.split(".");
//     console.log(arr)
//     if (arr && arr[0] > 12 && arr[1]>3) {
//       return true
//     }else if (arr && arr[0] > 13 && arr[1] >= 0 ){
//       return true
//     } else {
//       return  false
//     }
//   }
// }
// //获取手机类型
// function getIos() {
//   if (!!navigator.userAgent.match(/cpu iphone os (.*?) like mac os/)) {
//       return 'IOS';
//   } else if (navigator.userAgent.indexOf("Android 10") > -1){
//       return 'Android10';
//   }
// }
//
// //判断是从微信还是QQ打开
// function is_QQ_WEIXIN(){
// var ua = navigator.userAgent.toLowerCase();
//   if( ua.match(/MicroMessenger/i) == "micromessenger") {
//       return 'WEIXIN'
//   } else if (ua.match(/QQ/i)=="qq") {
//       return 'QQ'
//   }
// }
//
// //添加水印
// function watermark(element,text) {
//   //默认设置
//   var defaultSettings={
//     watermarl_element:element,
//     watermark_txt:text,
//     watermark_x:10,//水印起始位置x轴坐标
//     watermark_y:10,//水印起始位置Y轴坐标
//     watermark_rows:2000,//水印行数
//     watermark_cols:2000,//水印列数
//     watermark_x_space:20,//水印x轴间隔
//     watermark_y_space:20,//水印y轴间隔
//     watermark_color:'#333',//水印字体颜色
//     watermark_alpha:0.5,//水印透明度
//     watermark_fontsize:'12px',//水印字体大小
//     watermark_font:'微软雅黑',//水印字体
//     watermark_width:50,//水印宽度
//     watermark_height:50,//水印长度
//     watermark_angle:15//水印倾斜度数
//   };
//   //采用配置项替换默认值，作用类似jquery.extend
//   if(arguments.length===1&&typeof arguments[0] ==="object" ) {
//     var src=arguments[0]||{};
//     for(key in src) {
//       if(src[key]&&defaultSettings[key]&&src[key]===defaultSettings[key]){
//         continue;
//       } else if(src[key]){
//         defaultSettings[key]=src[key];
//       }
//     }
//   }
//
//   var oTemp = document.createDocumentFragment();
//
//   var maskElement=document.getElementById(defaultSettings.watermarl_element) || document.body;
//   //获取页面最大宽度
//   var page_width = Math.max(maskElement.scrollWidth,maskElement.clientWidth);
//   //获取页面最大高度
//   var page_height = Math.max(maskElement.scrollHeight,maskElement.clientHeight,maskElement.scrollTop);
//   //水印数量自适应元素区域尺寸
//   defaultSettings.watermark_cols=Math.round(page_width/(defaultSettings.watermark_x_space+defaultSettings.watermark_width));
//   defaultSettings.watermark_rows=Math.round(page_height/(defaultSettings.watermark_y_space+defaultSettings.watermark_height));
//   var x;
//   var y;
//   for (var i = 0; i < defaultSettings.watermark_rows; i++) {
//     y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i;
//     for (var j = 0; j < defaultSettings.watermark_cols; j++) {
//       x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) * j;
//       var mask_div = document.createElement('div');
//       mask_div.id = 'mask_div' + i + j;
//       mask_div.className = 'mask_div';
//       //mask_div.appendChild(document.createTextNode(defaultSettings.watermark_txt));
//       mask_div.innerHTML=(defaultSettings.watermark_txt);
//       //设置水印div倾斜显示
//       mask_div.style.webkitTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
//       mask_div.style.MozTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
//       mask_div.style.msTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
//       mask_div.style.OTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
//       mask_div.style.transform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
//       mask_div.style.visibility = "";
//       mask_div.style.position = "absolute";
//       mask_div.style.left = x + 'px';
//       mask_div.style.top = y + 'px';
//       mask_div.style.overflow = "hidden";
//       mask_div.style.whiteSpace= "nowrap";
//       mask_div.style.zIndex = "1029"; // 9999
//       // pointer-events:none  让水印不遮挡页面的点击事件
//       mask_div.style.pointerEvents='none';
//       // 设置边框
//       // mask_div.style.border="solid #eee 1px";
//       // 兼容IE9以下的透明度设置
//       mask_div.style.filter="alpha(opacity=50)";
//       mask_div.style.opacity = defaultSettings.watermark_alpha;
//       mask_div.style.fontSize = defaultSettings.watermark_fontsize;
//       mask_div.style.fontFamily = defaultSettings.watermark_font;
//       mask_div.style.color = defaultSettings.watermark_color;
//       mask_div.style.textAlign = "center";
//       // mask_div.style.width = defaultSettings.watermark_width + 'px';
//       // mask_div.style.height = defaultSettings.watermark_height + 'px';
//       mask_div.style.display = "block";
//       oTemp.appendChild(mask_div);
//     };
//   };
//   maskElement.appendChild(oTemp);
// }

export {
  IsPC,
  // deepClone,
  // compress,
  // getQueryString,
  // compresstypeB,
  // getIos,
  // is_QQ_WEIXIN,
  // watermark
};



// WEBPACK FOOTER //
// ./static/js/tool.js